import axios from "axios";

const API = axios.create({ baseURL: "https://api.scoriva.net/api" });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token"); // səndə token adı başqa isə dəyiş
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const usersApi = {
  list: () => API.get("/users"),
  get: (id) => API.get(`/users/${id}`),
  create: (dto) => API.post("/users", dto),
  update: (id, dto) => API.put(`/users/${id}`, dto),
  setRole: (id, dto) => API.put(`/users/${id}/role`, dto),
  resetPassword: (id, dto) => API.put(`/users/${id}/reset-password`, dto),
  remove: (id) => API.delete(`/users/${id}`),
};
